import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';

import { getContent, getErrorMessage } from '../../../util/responseUtil';
import { ROUTER_CONSTANT } from '../../../constants/routerConstant';
import API_MASTER_DATA from '../../../api/apiMasterData';
import IconPlusCircleBlue from '../../../assets/icons/IconPlusCircleBlue';
import IconEditWhite from '../../../assets/icons/IconEditWhite';
import IconDeleteWhite from '../../../assets/icons/IconDeleteWhite';
import ActionType from '../../../redux/reducer/globalActionType';
import Alert from '../../../components/Alert/Alert';
import { CheckPermissionComponent } from '../../../util/permission';
import { MASTER_DATA_DATA_CUSTOMER_VIEW } from '../../../constants/menuPermissionConstant';

class DataDistributor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            customer: {
                page: 1,
                limit: 10,
                data: [],
                value: 0
            },
            dataCustomer: {
                data: []
            },
            principal: {
                page: 1,
                limit: 10,
                data: [],
                value: 0
            },
            nsCode: '',
            branchId: '',
            clientId: '',
            distributorCode: '',
            status: {
                data: [
                    {
                        value: 'A',
                        label: 'Aktif'
                    },
                    {
                        value: 'E',
                        label: 'Kadaluwarsa'
                    },
                ],
                value: [],
            },
            showAddDataCustomer: false,
            showSubmitButton: false,
            showSuccessAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    getListCustomer = () => {
        API_MASTER_DATA.getListDistributorDataCustomer(this.state.customer.page, this.state.customer.limit, this.props.token)
            .then(res => {
                let customerList = getContent(res).map(customer => ({
                    value: customer.id,
                    label: customer.customer_name
                }))
                if (this._isMounted) {
                    this.setState({
                        customer: {
                            ...this.state.customer,
                            data: customerList
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchCustomer = keyword => {
        API_MASTER_DATA.getSearchDistributorDataCustomer(this.state.customer.page, this.state.customer.limit, keyword, this.props.token)
            .then(res => {
                let customerList = getContent(res).map(customer => ({
                    value: customer.id,
                    label: customer.customer_name
                }))
                this.setState({
                    customer: {
                        ...this.state.customer,
                        data: customerList
                    }
                });
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListDataCustomer = data => {
        API_MASTER_DATA.getListDataCustomer(data.value, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        dataCustomer: {
                            ...this.state.dataCustomer,
                            data: getContent(res).ns_list === null ? [] : getContent(res).ns_list
                        }
                    })
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getListPrincipal = () => {
        API_MASTER_DATA.getListPrincipalDataCustomer(this.state.principal.page, this.state.principal.limit, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(customer => ({
                        value: customer.id,
                        label: customer.customer_name,
                        code: customer.customer_code

                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    getSearchPrincipal = keyword => {
        API_MASTER_DATA.getSearchPrincipalDataCustomer(this.state.principal.page, this.state.principal.limit, keyword, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    let principalList = getContent(res).map(customer => ({
                        value: customer.id,
                        label: customer.customer_name,
                        code: customer.customer_code

                    }))
                    this.setState({
                        principal: {
                            ...this.state.principal,
                            data: principalList
                        }
                    });
                }
            }).catch(err => {
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSearchCustomer = keyword => {
        if (keyword !== '') {
            return this.getSearchCustomer(keyword)
        }
        return this.getListCustomer()
    }

    handleSearchPrincipal = keyword => {
        if (keyword !== '') {
            return this.getSearchPrincipal(keyword)
        }
        return this.getListPrincipal()
    }

    handleChangeCustomer = data => {
        this.setState({
            customer: {
                ...this.state.customer,
                value: data
            }
        })
        this.getListDataCustomer(data)
    }

    handleChangePrincipal = data => {
        this.setState({
            principal: {
                ...this.state.principal,
                value: data
            },
            nsCode: data.code
        })
    }

    handleChangeAddStatus = data => {
        this.setState({
            status: {
                ...this.state.status,
                value: data
            }
        })
    }

    handleChangeEditNS = (e, dataCustomer) => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].ns = e.target.value

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            }
        })
    }

    handleChangeEditBranchId = (e, dataCustomer) => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].branch_id = e.target.value

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            }
        })
    }

    handleChangeEditClientId = (e, dataCustomer) => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].client_id = e.target.value

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            }
        })
    }

    handleChangeEditDistributorCode = (e, dataCustomer) => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].distributor_code = e.target.value

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            }
        })
    }

    handleChangeEditStatusLicense = (e, dataCustomer) => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].license = e.target.value

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            }
        })
    }

    handleShowAddDataCustomer = () => {
        if (this.state.customer.value !== 0) {
            this.setState({
                showAddDataCustomer: true,
                showSubmitButton: true
            })
            this.getListPrincipal()
        }
    }

    handleAddDataCustomer = () => {
        if (this.state.nsCode !== '') {
            const data = {
                id: this.state.customer.value.value,
                status: 1,
                principal_id: this.state.principal.value.value,
                ns: this.state.nsCode,
                branch_id: this.state.branchId,
                client_id: this.state.clientId,
                license: this.state.status.value.value,
                distributor_code: this.state.distributorCode,
                principal_name: this.state.principal.value.label,
                ns_code_detail: null,
                created_at: '',
                updated_at: ''
            }
            this.setState({
                dataCustomer: {
                    ...this.state.dataCustomer,
                    data: [...this.state.dataCustomer.data, data]
                },
                showAddDataCustomer: false
            })
        }
    }

    handleEditDataCustomer = dataCustomer => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].status = 2

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            },
            showSubmitButton: true
        })
    }

    handleDeleteDataCustomer = dataCustomer => {
        let idx = this.state.dataCustomer.data.findIndex(customer => customer.id === dataCustomer.id)

        let tempData = [...this.state.dataCustomer.data]
        tempData[idx].status = 3

        this.setState({
            dataCustomer: {
                ...this.state.dataCustomer,
                data: tempData
            },
            showSubmitButton: true
        })
    }

    handleCancelDataCustomer = () => {
        window.location.reload()
    }

    handleSubmitDataCustomer = () => {
        const data = {
            customer_id: this.state.customer.value.value,
            ns_list: this.state.dataCustomer.data
        }

        API_MASTER_DATA.postDataDataCustomer(data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showSuccessAlert: true
                    })
                    setTimeout(() => window.location.reload(), 1500)
                }
            }).catch(err => {
                this.setState({
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                })
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getListCustomer();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_CUSTOMER_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="flex text-gray-600 white-container calculate-layout">
                    <div className="w-full bg-white rounded-lg p-5 relative">
                        <div className="w-full flex justify-between mb-5">
                            <div className="w-1/2 flex items-center">
                                <div className="w-20 text-right font-bold mr-2">Nama Distributor</div>
                                <div className="w-3/4">
                                    <Select
                                        id="ddscustomer"
                                        placeholder="Pilih Distributor"
                                        options={this.state.customer.data}
                                        value={this.state.customer.value}
                                        onChange={this.handleChangeCustomer}
                                        onInputChange={this.handleSearchCustomer}
                                    />
                                </div>
                            </div>
                            <div className="border border-softblue rounded-full px-5 py-2 flex items-center cursor-pointer select-none" id="btnaddcolumn" onClick={() => this.handleShowAddDataCustomer()}>
                                <IconPlusCircleBlue />
                                <span className="ml-2 text-softblue font-bold">Tambah Kolom</span>
                            </div>
                        </div>
                        <div className={this.state.showSubmitButton ? this.state.showAddDataCustomer ? "bg-white mb-40 shadow-lg relative" : "bg-white mb-40 shadow-lg relative rounded-b-xl" : this.state.showAddDataCustomer ? "bg-white mb-3 shadow-lg relative" : "bg-white mb-3 shadow-lg relative rounded-b-xl"}>
                            <div className="flex justify-between bg-darkgrey text-gray-700 font-medium px-14 py-5 rounded-t-xl">
                                <div className="w-44">Nama Principal</div>
                                <div className="w-48">Company ID</div>
                                <div className="w-40">Kode Cabang</div>
                                <div className="w-80">Klien ID</div>
                                <div className="w-32">Kode Distributor</div>
                                <div className="w-32">Status</div>
                                <div className="w-40">Aksi</div>
                            </div>
                            <div className={this.state.showAddDataCustomer ? "overflow-auto relative" : "overflow-auto relative rounded-b-xl"} style={{ maxHeight: "40vh" }}>
                                {
                                    this.state.dataCustomer.data.length > 0
                                        ? <div>
                                            {
                                                this.state.dataCustomer.data.map((data, idx) =>
                                                    <div className={data.status === 2 ? "pt-5 px-10 bg-blue-100" : "pt-5 px-10 hover:bg-blue-100"} key={idx}>
                                                        <div className={this.state.dataCustomer.data.length === idx + 1 && !this.state.showAddDataCustomer ? "pb-5 px-5 text-gray-700 flex justify-between" : "pb-5 px-5 text-gray-700 flex justify-between border-b-2 border-gray"}>
                                                            <div className="w-44">{data.principal_name === "" ? "-" : data.principal_name}</div>
                                                            <div className="w-48">
                                                                {
                                                                    data.status === 2
                                                                        ? <input type="text" id="tslnscode" defaultValue={data.ns} onChange={e => this.handleChangeEditNS(e, data)} className="w-full" />
                                                                        : data.ns === "" ? "-" : data.ns
                                                                }
                                                            </div>
                                                            <div className="w-40">
                                                                {
                                                                    data.status === 2
                                                                        ? <input type="text" id="tslbranchid" defaultValue={data.branch_id} onChange={e => this.handleChangeEditBranchId(e, data)} className="w-full" />
                                                                        : data.branch_id === "" ? "-" : data.branch_id
                                                                }
                                                            </div>
                                                            <div className="w-80">
                                                                {
                                                                    data.status === 2
                                                                        ? <input type="text" id="tslclientid" defaultValue={data.client_id} onChange={e => this.handleChangeEditClientId(e, data)} className="w-full" />
                                                                        : data.client_id === "" ? "-" : data.client_id
                                                                }
                                                            </div>
                                                            <div className="w-32">
                                                                {
                                                                    data.status === 2
                                                                        ? <input type="text" id="tsldistributorcode" defaultValue={data.distributor_code} onChange={e => this.handleChangeEditDistributorCode(e, data)} className="w-full" />
                                                                        : data.distributor_code === "" ? "-" : data.distributor_code
                                                                }
                                                            </div>
                                                            <div className="w-32">
                                                                {
                                                                    data.status === 2
                                                                        ? <select id="ddllicense" onChange={e => this.handleChangeEditStatusLicense(e, data)} value={data.license} className="w-full">
                                                                            <option value="A">Aktif</option>
                                                                            <option value="E">Kadaluwarsa</option>
                                                                        </select>
                                                                        : data.license === "A" ? "Aktif" : data.license === "E" ? "Kadaluwarsa" : ""
                                                                }
                                                            </div>
                                                            <div className="w-40 flex">
                                                                {
                                                                    data.status !== 1 && data.status !== 2 && data.status !== 3
                                                                        ? <div className="flex items-center w-full">
                                                                            <div className="cursor-pointer mr-2 bg-darkblue rounded-full flex items-center px-2 py-1" id="btneditdatacustomer" onClick={() => this.handleEditDataCustomer(data)}>
                                                                                <IconEditWhite />
                                                                                <span className="text-white font-bold ml-1">Ubah</span>
                                                                            </div>
                                                                            <div className="cursor-pointer mr-2 bg-darkblue rounded-full flex items-center px-2 py-1" id="btndeletedatacustomer" onClick={() => this.handleDeleteDataCustomer(data)}>
                                                                                <IconDeleteWhite />
                                                                                <span className="text-white font-bold ml-1">Hapus</span>
                                                                            </div>
                                                                        </div>
                                                                        : data.status === 2
                                                                            ? <div className="cursor-pointer mr-2" id="btneditdatacustomer" onClick={() => this.handleEditDataCustomer(data)}>
                                                                                <div className="cursor-pointer mr-2 bg-darkblue rounded-full flex items-center px-2 py-1" id="btneditdatacustomer" onClick={() => this.handleEditDataCustomer(data)}>
                                                                                    <IconEditWhite />
                                                                                    <span className="text-white font-bold ml-1">Diubah</span>
                                                                                </div>
                                                                            </div>
                                                                            : data.status === 3
                                                                                ? <div className="cursor-pointer mr-2 bg-darkblue rounded-full flex items-center px-2 py-1" id="btndeletedatacustomer" onClick={() => this.handleDeleteDataCustomer(data)}>
                                                                                    <IconDeleteWhite />
                                                                                    <span className="text-white font-bold ml-1">Dihapus</span>
                                                                                </div>
                                                                                : <div className="mr-2 bg-darkblue rounded-full flex items-center px-2 py-1">
                                                                                    <span className="text-white font-bold ml-1">Data Baru</span>
                                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </div>
                                        : <div className="flex justify-center items-center text-2xl font-bold" style={{ height: "40vh" }}>
                                            <p>Tidak ada data</p>
                                        </div>
                                }
                            </div>
                            {
                                this.state.showAddDataCustomer &&
                                <div className="pt-5 px-10 bg-blue-100 absolute top-full w-full shadow-lg rounded-b-xl">
                                    <div className="pb-5 px-5 text-gray-700 flex justify-between">
                                        <div className="w-40">
                                            <Select
                                                id="ddsprincipal"
                                                placeholder="Pilih Principal"
                                                options={this.state.principal.data}
                                                value={this.state.principal.value}
                                                onChange={this.handleChangePrincipal}
                                                onInputChange={this.handleSearchPrincipal}
                                            />
                                        </div>
                                        <div className="w-48">
                                            <input type="text" id="tslnscode" className="form-control" name="nsCode" value={this.state.nsCode} placeholder="Company ID" onChange={this.handleChange} />
                                        </div>
                                        <div className="w-40">
                                            <input type="text" id="tslbranchid" className="form-control" name="branchId" value={this.state.branchId} placeholder="Kode Cabang" onChange={this.handleChange} />
                                        </div>
                                        <div className="w-80">
                                            <input type="text" id="tslclientid" className="form-control" name="clientId" value={this.state.clientId} placeholder="Klien ID" onChange={this.handleChange} />
                                        </div>
                                        <div className="w-32">
                                            <input type="text" id="tsldistributorcode" className="form-control" name="distributorCode" value={this.state.distributorCode} placeholder="Kode Distributor" onChange={this.handleChange} />
                                        </div>
                                        <div className="w-32">
                                            <Select
                                                id="ddsstatus"
                                                placeholder="Status"
                                                options={this.state.status.data}
                                                value={this.state.status.value}
                                                onChange={this.handleChangeAddStatus}
                                            />
                                        </div>
                                        <div className="w-40">
                                            <div className="cursor-pointer bg-darkblue rounded-full text-white text-center font-bold w-full px-2 py-1" id="btnadddatacustomer" onClick={() => this.handleAddDataCustomer()}>
                                                Tambah
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={this.state.showSubmitButton ? "absolute bottom-5 right-5" : "hidden"}>
                            <button type="button" id="btncancel" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none px-10 py-2 mt-3 mr-2" onClick={() => this.handleCancelDataCustomer()}>Batal</button>
                            <button type="button" id="btnsave" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none px-10 py-2 mt-3 ml-2" onClick={() => this.handleSubmitDataCustomer()}>Simpan</button>
                        </div>
                        <Alert show={this.state.showSuccessAlert} icon="success" title="Berhasil Mengupdate Data Customer!" />
                        <Alert show={this.state.showErrorAlertResponse} icon="warning" title={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                    </div>
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DataDistributor);